import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Drawer,
  ListItem,
  ListItemIcon,
  ListItemText,
  useTheme,
  List,
  Tooltip,
  useMediaQuery,
  ListSubheader,
} from '@material-ui/core';
import { SvgIconComponent } from '@material-ui/icons';
import clsx from 'clsx';

import { useStyles } from './styles';
import { useRoutes } from '../../contexts/routes.context';

type SidebarProps = {
  isDrawerOpen?: boolean;
  onDrawerClose?: () => void;
  onClick?: () => void;
};

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const emptyFunction = (): void => {};
 
function SidebarListItem({
  route,
  label,
  Icon,
  isDrawerOpen,
  className,
  onDrawerClose,
  onClick,
  isXS,
}: {
  route: string;
  label: string;
  Icon?: SvgIconComponent;
  isDrawerOpen?: boolean;
  className: string;
  onDrawerClose?: () => void;
  onClick?: () => void;
  isXS: boolean;
}): JSX.Element {
  const { pathname } = useLocation();
  return (
    <ListItem
      button
      className={clsx(className, {
        'sidebar-nav-active': pathname.startsWith(route),
      })}
      component={Link}
      to={route}
      onClick={onClick ?? (isXS ? onDrawerClose : emptyFunction)}
    >
      <ListItemIcon>{!!Icon && <Icon />}</ListItemIcon>
      <ListItemText primary={label} hidden={!isDrawerOpen} />
    </ListItem>
  );
}

export default function Sidebar({ isDrawerOpen, onDrawerClose }: SidebarProps): JSX.Element {
  const classes = useStyles();
  const theme = useTheme();
  const isXS = useMediaQuery(theme.breakpoints.down('xs'));
  const { routes } = useRoutes();

  const dashboardItems = useMemo(
    () => routes
      .filter((r) => r.sidebar === true && r.dashboard === true)
      .map(({ icon: Icon, label = '', route }) => (
        <Tooltip
          title={label}
          key={label}
          placement="right"
          arrow
          disableHoverListener={isDrawerOpen}
        >
          <SidebarListItem
            route={route}
            label={label}
            Icon={Icon}
            className={clsx(classes.drawerListItem, {
              [classes.drawerListItemShift]: !isDrawerOpen,
            })}
            isDrawerOpen={isDrawerOpen}
            onDrawerClose={onDrawerClose}
            isXS={isXS}
          />
        </Tooltip>
      )),
    [routes, isDrawerOpen],
  );
  const listItems = useMemo(
    () => routes
      .filter((r) => r.sidebar === true && !r.dashboard && !r.quickAccess)
      .map(({ icon: Icon, label = '', route, onClick }) => (
        <Tooltip
          title={label}
          key={label}
          placement="right"
          arrow
          disableHoverListener={isDrawerOpen}
        >
          <SidebarListItem
            route={route}
            label={label}
            Icon={Icon}
            className={clsx(classes.drawerListItem, {
              [classes.drawerListItemShift]: !isDrawerOpen,
            })}
            isDrawerOpen={isDrawerOpen}
            onDrawerClose={onDrawerClose}
            isXS={isXS}
            onClick={onClick}
          />
        </Tooltip>
      )),
    [routes, isDrawerOpen],
  );

  return (
    <Drawer
      variant={isXS ? 'temporary' : 'permanent'}
      open={isDrawerOpen}
      ModalProps={{
        keepMounted: true,
      }}
      onClose={onDrawerClose}
      className={clsx(classes.drawer, {
        [classes.drawerOpen]: isDrawerOpen,
        [classes.drawerClose]: !isDrawerOpen,
      })}
      classes={{
        paper: clsx({
          [classes.drawerOpen]: isDrawerOpen,
          [classes.drawerClose]: !isDrawerOpen,
        }),
      }}
    >
      {/* <List
        className={clsx('sidebar-nav', classes.drawerList, {
          'sidebar-nav-shift': !isDrawerOpen,
          [classes.drawerListShift]: !isDrawerOpen,
        })}
        subheader={(
          <ListSubheader component="div" className={classes.listSubheader}>
            {isDrawerOpen ? 'Navegue abaixo' : <>&nbsp;</>}
          </ListSubheader>
        )}
      >
        {dashboardItems}
      </List> */}
      <List
        className={clsx('sidebar-nav', classes.drawerList, {
          'sidebar-nav-shift': !isDrawerOpen,
          [classes.drawerListShift]: !isDrawerOpen,
        })}
        subheader={(
          <ListSubheader component="div" className={classes.listSubheader}>
            {isDrawerOpen ? 'Menu' : ''}
          </ListSubheader>
        )}
      >
      {listItems}
      </List>
    </Drawer>
  );
}
